import { ChangeEvent, FC, useCallback } from 'react';

import { Cell, CellText, Radio, VSpacingContainer } from '@hh.ru/magritte-ui';

import useTrls from 'hooks/translation/useTrls';

import { MagritteFormField } from 'components/common/MagritteFormField/MagritteFormField';
import { SalaryInputs } from 'components/CpcFlexibleCreate/CpcForm/AdSalaries/SalaryInputs/SalaryInputs';

import { setCampaignErrors, setCampaignSalary } from 'store/models/createCampaign';
import { useDispatch, useSelector } from 'store/utils';

const TrlKeys = {
    legend: 'AdCreate.AdForm.AdSalary.legend',
    disabled: 'AdCreate.AdForm.AdSalary.disabled',
    enabled: 'AdCreate.AdForm.AdSalary.enabled',
};

const IS_TARGETING_ENABLED = 'enabled';

export const AdSalaries: FC = () => {
    const { adSalary, campaignErrors } = useSelector((state) => state.createCampaign);

    const salaryTargetingEnabled = adSalary !== null;

    const dispatch = useDispatch();
    const trl = useTrls();

    const handleRadioChange = useCallback(
        (event: ChangeEvent<HTMLInputElement>) => {
            const isEnabled = event.target.value === IS_TARGETING_ENABLED;
            if (isEnabled) {
                dispatch(setCampaignSalary({ min: null, max: null }));
            } else {
                dispatch(setCampaignSalary(null));
                dispatch(
                    setCampaignErrors({
                        ...campaignErrors,
                        adSalaryMin: undefined,
                        adSalaryMax: undefined,
                        adSalaryCommon: undefined,
                    })
                );
            }
        },
        [dispatch, campaignErrors]
    );

    return (
        <MagritteFormField
            label={trl(TrlKeys.legend)}
            input={
                <VSpacingContainer default={12}>
                    <Cell
                        width="fit-content"
                        left={
                            <Radio
                                name="salaryTargeting"
                                value="disabled"
                                checked={!salaryTargetingEnabled}
                                onChange={handleRadioChange}
                                data-qa="salary-targeting-disabled"
                            />
                        }
                    >
                        <CellText>{trl(TrlKeys.disabled)}</CellText>
                    </Cell>
                    <Cell
                        width="fit-content"
                        left={
                            <Radio
                                name="salaryTargeting"
                                value="enabled"
                                checked={salaryTargetingEnabled}
                                onChange={handleRadioChange}
                                data-qa="salary-targeting-enabled"
                            />
                        }
                    >
                        <CellText>{trl(TrlKeys.enabled)}</CellText>
                    </Cell>
                    {salaryTargetingEnabled && <SalaryInputs />}
                </VSpacingContainer>
            }
            vSpacingBottom={32}
        />
    );
};
